import { render, staticRenderFns } from "./PostalCodeComponent.vue?vue&type=template&id=745d2be4"
import script from "./PostalCodeComponent.vue?vue&type=script&lang=js"
export * from "./PostalCodeComponent.vue?vue&type=script&lang=js"
import style0 from "./PostalCodeComponent.vue?vue&type=style&index=0&id=745d2be4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports